import React, { useEffect /*,useState*/ } from "react";
import { Auth } from "aws-amplify";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import {
  View,
  Divider,
  Expander,
  ExpanderItem,
  ThemeProvider,
} from "@aws-amplify/ui-react";

import UserInfoTable from "./UserInfoTable.js";
import AccountManageGamen from "./AccountManageGamen.tsx";
import { UpdateEmail } from "./UpdateEmail";
import DeleteUserButton from "./DeleteUserButton";

const AccountInfoModal = (props) => {
  const [currentUser, setCurrentUser] = React.useState("");
  useEffect(() => {
    const init = async () => {
      const ret = await Auth.currentAuthenticatedUser({ bypassCache: true }); // これで最新情報を取得。ただし画面の再読込は必要
      setCurrentUser(ret.attributes);
    };
    init();
  }, []);

  const theme = {
    name: "expander-theme",
    tokens: {
      components: {
        expander: {
          backgroundColor: { value: "{colors.blue.10}" },
          borderRadius: { value: "{radii.small}" },
          trigger: {
            justifyContent: { value: "center" },
            _hover: {
              backgroundColor: { value: "{colors.overlay.20}" },
            },
          },
          content: {
            text: {
              color: { value: "{colors.blue.80}" },
            },
            _open: {
              animationDuration: { value: "{time.short}" },
            },
          },
        },
      },
    },
  };

  return (
    <>
      <Modal {...props}>
        <Modal.Header>
          <Modal.Title>アカウント情報</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UserInfoTable userinfo={currentUser}></UserInfoTable>
          <AccountManageGamen userinfo={{ currentUser, setCurrentUser }} />
          <Divider size="small" orientation="horizontal" />
          <UpdateEmail userinfo={currentUser} />
          <Divider size="small" orientation="horizontal" />
          <ThemeProvider theme={theme} colorMode="light">
            <Expander
              type="single"
              isCollapsible={true}
              style={{ marginTop: "10px" }}
              className="d-grid col-6 mx-auto"
            >
              <ExpanderItem
                title="アカウント削除"
                value="item-2"
                style={{ fontSize: "small" }}
              >
                <View style={{ fontSize: "small", marginTop: "10px" }}>
                  アカウントを削除すると自動的にログアウトされます。再度ご利用いただく場合は、改めてアカウント登録をお願いいたします。
                  <br />
                  サブスクリプションをご利用中のアカウントは削除できません。あらかじめ、サブスクリプションメニューから解約手続きを行ってください。
                </View>
                <View className="d-flex flex-column align-items-center">
                  <DeleteUserButton />
                </View>
              </ExpanderItem>
            </Expander>
          </ThemeProvider>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="link" onClick={props.onHide}>
            閉じる
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AccountInfoModal;
